/**
 * @generated SignedSource<<fb5c77558ad1c9a98934be23988ef116>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type OSType = "FreeBSD" | "Linux" | "Solaris" | "Unix" | "Unknown" | "Windows" | "macOS";
import { FragmentRefs } from "relay-runtime";
export type AssignAgentsDialogAgentFragment$data = {
  readonly connected: boolean | null;
  readonly enabled: boolean | null;
  readonly environment: {
    readonly os: {
      readonly type: OSType;
    } | null;
  } | null;
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentType": "AssignAgentsDialogAgentFragment";
};
export type AssignAgentsDialogAgentFragment$key = {
  readonly " $data"?: AssignAgentsDialogAgentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssignAgentsDialogAgentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssignAgentsDialogAgentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "connected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgentEnvironment",
      "kind": "LinkedField",
      "name": "environment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OS",
          "kind": "LinkedField",
          "name": "os",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Agent",
  "abstractKey": null
};

(node as any).hash = "8a7b5411cc45d6d52d608f81212a1b44";

export default node;
